// AUTO-GENERATED by scripts/build-registry.js: study entry for meteorology/jet-stream.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/meteorology/jet-stream/jet-stream.js';

mount([g0]);
